import { ref } from "vue";
import { defineStore } from "pinia";
import { IKeyValue } from "./app-store";
import { commClient } from "fw4-library";
import { provide } from "vue";

interface IGeneralStore {
    countryList : IKeyValue[] | undefined;
    countryPhoneList: IKeyValue[] | undefined;
    postalCodeList: IKeyValue[] | undefined;
}

export const useGeneralStore = defineStore("generalStore", () => {
    const state = ref<IGeneralStore>({
        countryList: undefined,
        countryPhoneList: undefined,
        postalCodeList: undefined,
    });

    async function loadCountryLoad() {
        if (state.value.countryList == undefined) {
            const Message: any = await commClient.executeMethodAsync("sf.CountryList",{});
            if (Message) {  
                state.value.countryList = Message as IKeyValue[];
            }
        }
        return state.value.countryList;
    }

    async function postalCodeLoad() {
        if (state.value.postalCodeList == undefined) {
            const Message: any = await commClient.executeMethodAsync("sf.PostalCode",{});
            if (Message) {  
                state.value.postalCodeList = Message as IKeyValue[];
            }
        }

        return state.value.postalCodeList;
    }

    async function countryPhoneLoad() {
        if (state.value.countryPhoneList == undefined) {
            const Message: any = await commClient.executeMethodAsync("sf.CountryPhoneList",{});
            if (Message) {  
                state.value.countryPhoneList = Message as IKeyValue[];
            }
        }

        return state.value.countryPhoneList;
    }

    return { 
        state,
        loadCountryLoad,
        postalCodeLoad,
        countryPhoneLoad
    };
});